import React from "react";

export const GreVisitorFormStepBar = ({ steps = [] }) => (
  <div className="gre-step-bar" aria-label="Form sections">
    {steps.map((step, index) => (
      <React.Fragment key={step}>
        <div className="gre-step-bar__item">
          <span className="gre-step-bar__number">{index + 1}</span>
          <span className="gre-step-bar__label">{step}</span>
        </div>
        {index < steps.length - 1 && (
          <span className="gre-step-bar__connector" aria-hidden="true" />
        )}
      </React.Fragment>
    ))}
  </div>
);

export const GreVisitorFormSectionHeader = ({ step, title }) => (
  <div className="gre-section-header">
    <span className="gre-section-header__badge">{step}</span>
    <h6 className="gre-section-header__title">{title}</h6>
  </div>
);
